/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name datatable
 * @description Data table directive to allow simple pagination and ordering.
 * Can be used in 2 ways. Ether define the entire dataset with table-data attributes.
 * Or define a partial data-set in table-data and use the table-count to set the total
 * and datatable-change to update the table-data when the datatable state changes.
 *
 * @attr {Object} options An object of options to define how the datatable will behave
 * @attr {Number} table-count
 * @attr {Function} datatable-onchange
 * @attr {Object} table-data
 */
angular.module('mercury.directives.datatable', [])
.directive('datatable', ["$filter", "$parse", "$timeout", function($filter, $parse, $timeout) {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    templateUrl: 'directives/datatable/datatable.tpl.html',
    link: function(scope, element, attrs) {
      scope.$datatable = {
        rows: [],
        count: 0,
        page: 1,
        limit: 20,
        order: null,
        desc: false,
        totalPages: 1,
        pagination: true,
        filter: '',
        filterColumns: []
      };

      if (attrs.options) {
        scope.$datatable = angular.extend(scope.$datatable, $parse(attrs.options)(scope));

        // Watch for external changes to the datatable options.
        scope.$watch(attrs.options, function() {
          scope.$datatable = angular.extend(scope.$datatable, $parse(attrs.options)(scope));

          scope.updateTable();
        });
      }

      scope.pageLabel = '0 to 0';

      scope.pageOptions = [
        {label: '10', value: 10},
        {label: '20', value: 20},
        {label: '50', value: 50},
        {label: '100', value: 100}
      ];

      var processResults = function(results) {
        if (!angular.isArray(results)) {
          scope.$datatable.count = 0;
          scope.$datatable.rows = [];
          return;
        }
        //If a table count is specified, the full model isn't being held on the front
        //end. Assume any filtering, and ordering is being done elsewhere so
        //just show the rows as is.
        if (attrs.tableCount) {
          scope.$datatable.count = $parse(attrs.tableCount)(scope);
          scope.$datatable.rows = angular.copy(results);
        } else {
          scope.$datatable.rows = results;

          if (scope.$datatable.order) {
            scope.$datatable.rows = $filter('orderBy')(scope.$datatable.rows, scope.$datatable.order, scope.$datatable.desc);
          }

          if (scope.$datatable.filter) {
            scope.$datatable.rows = $filter('filter')(scope.$datatable.rows, function(row) {
              var match = false;
              angular.forEach(scope.$datatable.filterColumns, function(column) {
                match = match || row[column].toLowerCase().indexOf(scope.$datatable.filter) != -1;
              });
              return match;
            });
          }

          scope.$datatable.count = scope.$datatable.rows.length;

          if (!scope.$datatable.pagination) {
            return;
          }

          if (results.length > scope.$datatable.limit) {
            scope.$datatable.rows = scope.$datatable.rows.slice((scope.$datatable.page - 1) *
            scope.$datatable.limit, (scope.$datatable.page * scope.$datatable.limit));
          }
        }

        scope.$datatable.totalPages = Math.ceil(scope.$datatable.count / scope.$datatable.limit);

        var start = (((scope.$datatable.page - 1) * scope.$datatable.limit) + 1);
        var end = (scope.$datatable.page * scope.$datatable.limit);

        if (end > scope.$datatable.count) {
          end = scope.$datatable.count;
        }

        if (scope.$datatable.count === 0) {
          start = 0;
        }

        scope.pageLabel = start + ' to ' + end;

        // Support a callback being provided by the parent controller to receive
        // the current page of data. Useful for things that should happen based
        // only on what is currently being displayed.
        if (attrs.pageCallback) {
          var pageCallbackFn = scope[attrs.pageCallback];
          if (pageCallbackFn) {
            pageCallbackFn(scope.$datatable.rows);
          }
        }
      };

      scope.updateTable = function() {
        //If an onchange method is defined, call that instead of evaling the
        //table data. The onchange method should update the model which will
        //trigger the watcher below.
        if (attrs.datatableOnchange) {
          scope.$eval(attrs.datatableOnchange);
        } else {
          processResults(scope.$eval(attrs.tableData));
        }
      };

      //Watch from changes in the table data
      scope.$watch(attrs.tableData, function(newTableData) {
        processResults(newTableData);
      });

      //Listen for events from the controller to say the table should refresh the view.
      scope.$on('dataTableUpdate', function() {
        scope.updateTable();
      });

      $timeout(function() {
        //Add the sort indicators to the columns with the sortable attribute
        $('th[sortable]').each(function() {
          if ($(this).hasClass('right-align')) {
            $(this).prepend('<span class="hide sort-desc">&#9660;');
            $(this).prepend('<span class="hide sort-asc">&#9650;');
          } else {
            $(this).append('<span class="hide sort-desc">&#9660;');
            $(this).append('<span class="hide sort-asc">&#9650;');
          }
        });

        //Add click event to sortable columns
        $('th[sortable]').on('click', function() {
          $('.sort-desc, .sort-asc').addClass('hide');

          var newOrder = $(this).attr('sortable');

          if (scope.$datatable.order == newOrder) {
            scope.$datatable.desc = !scope.$datatable.desc;
          } else {
            scope.$datatable.desc = $(this).hasClass('sortable-desc');
            scope.$datatable.order = newOrder;
          }

          $(this).find((scope.$datatable.desc) ? '.sort-desc' : '.sort-asc').removeClass('hide');

          //Since click events happen outside the angular digest cycle, wrap this in a $timeout so it will
          //be inlcuded in the next cycle and the model will receive the update.
          $timeout(function() {
            if (attrs.datatableOnchange) {
              scope.$eval(attrs.datatableOnchange);
            }

            scope.updateTable();
          });
        });

        //Set the sort default
        if ($('.sortable-default')) {
          var defaultSortElem = $('.sortable-default');

          scope.$datatable.order = defaultSortElem.attr('sortable');
          scope.$datatable.desc = defaultSortElem.hasClass('sortable-desc');

          defaultSortElem.find((scope.$datatable.desc) ? '.sort-desc' : '.sort-asc').removeClass('hide');
        }

        //Inital population of the table.
        scope.updateTable();
      });
    }
  };
}]);
